export enum PensionApplicationConditionEnum {
    ReachedPresAge = 1,
    CeasedPaidEmployment = 2,
    ReachedAgeSixtyFive = 3,
    OtherReason = 5,
    Ttr = 6
}